import React from 'react';

import './styles.css';

// defining the base style here to use the background color prop
const style = {
  padding: "16px 16px 18px",
  borderRadius: "10px 10px 10px 0px",
};

const Component = ({color, children}) => (
  <div className="graphicTextBox">
    <div style={{ ...style, backgroundColor: color }}>
      {children}
    </div>
    <svg width="24" height="20">
      <polygon points="0,0 24,0, 0,20"
               fill={color}
      />
    </svg>
  </div>
);

Component.displayName = 'GraphicTextBox';

export default Component;



// WEBPACK FOOTER //
// ./src/components/GraphicTextBox/index.js